import React, { useEffect, useState } from 'react';
import Footer from "./Footer";
import Header from "./Header";
import axios from 'axios';
import { Link } from "react-router-dom";
import image2 from "../Assets/wp3589952.webp";

function Privacy() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [privacyContent, setPrivacyContent] = useState("");
  const [isLoading, setIsLoading] = useState(true); // State to manage loading
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    const fetchPrivacyData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        // Inspect the response to ensure it has the expected structure
        console.log("API response:", response.data);

        // Destructure and check the 'privacy' data
        const { privacy } = response.data.body;
        console.log("Privacy content:", privacy);

        // Set privacyContent as a string
        setPrivacyContent(privacy);
      } catch (error) {
        console.error("Error fetching the privacy policy data", error);
      }finally {
              setIsLoading(false); // Stop loading after data is fetched
            }
    };

    fetchPrivacyData();
  }, []);

//   if (isLoading) {
//     return <CrackersLoader />; // Show the custom loader while fetching data
//   }

  return (
    <div>
      <div className="main">
        <Header />

        <div
  className="content-section"
  style={{ backgroundImage: `url(${image2})` }} 
>
                  <h1
                    style={{
                      color: "white",
                    
                      textAlign: "center",
                    }}
                  >
                   Privacy Policy
                  </h1>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      color: "white",
                    }}
                  >
                    <Link to="/" style={{color:"white"}}>
                      Home
                    </Link> <i className="bi bi-chevron-right"></i> Privacy Policy
                  </p>
                </div>
       

        <div className='privacy-content' style={{ padding: "20px" }}>
          {/* Render privacy content */}
          {/* Check if privacyContent is a string before rendering */}
          {isLoading ? null : (
          typeof privacyContent.value === 'string' ? (
            <p dangerouslySetInnerHTML={{ __html: privacyContent.value }} />
          ) : (
            <p>Content not available</p>
          )
          )}
        </div>

        
      </div>
      <Footer />
      
      
    </div>
    
  );
}

export default Privacy;
